export const UPGRADE_CATALOG = [
    {
        id: 'damage',
        label: 'Overcharge Rounds',
        desc: 'Projectile damage +8',
        icon: 'fa-fire-alt',
        color: '#FF8C00',
        rarity: 'common',
        apply(gs) { gs.stats.damage += 8; },
    },
    {
        id: 'fireRate',
        label: 'Rapid Fire',
        desc: 'Shoot cooldown −2 frames',
        icon: 'fa-crosshairs',
        color: '#A3E635',
        rarity: 'common',
        apply(gs) { gs.stats.fireRate = Math.max(4, gs.stats.fireRate - 2); },
    },
    {
        id: 'maxHealth',
        label: 'Reinforced Hull',
        desc: 'Max shield +25 · Restore 25 HP',
        icon: 'fa-shield-alt',
        color: '#22C55E',
        rarity: 'common',
        apply(gs) {
            gs.stats.maxHealth += 25;
            gs.health = Math.min(gs.stats.maxHealth, gs.health + 25);
        },
    },
    {
        id: 'maxEnergy',
        label: 'Extended Capacitor',
        desc: 'Max energy +30',
        icon: 'fa-bolt',
        color: '#8B5CF6',
        rarity: 'common',
        apply(gs) {
            gs.stats.maxEnergy += 30;
            gs.energy = Math.min(gs.stats.maxEnergy, gs.energy + 30);
        },
    },
    {
        id: 'energyRegen',
        label: 'Solar Relay',
        desc: 'Energy regeneration +0.3 / frame',
        icon: 'fa-sun',
        color: '#F59E0B',
        rarity: 'uncommon',
        apply(gs) { gs.stats.energyRegen += 0.3; },
    },
    {
        id: 'speedMult',
        label: 'Thruster Boost',
        desc: 'Movement speed +15%',
        icon: 'fa-tachometer-alt',
        color: '#38BDF8',
        rarity: 'uncommon',
        apply(gs) { gs.stats.speedMult *= 1.15; },
    },
    {
        id: 'shieldRegen',
        label: 'Nanobots',
        desc: 'Passively regenerate 0.05 shield/frame',
        icon: 'fa-heartbeat',
        color: '#22C55E',
        rarity: 'uncommon',
        apply(gs) { gs.stats.shieldRegen += 0.05; },
    },
    {
        id: 'piercingShots',
        label: 'Railgun Shots',
        desc: 'Projectiles pierce through all enemies',
        icon: 'fa-arrows-alt-h',
        color: '#FF3B3B',
        rarity: 'rare',
        available: (gs) => !gs.stats.piercingShots,
        apply(gs) { gs.stats.piercingShots = true; },
    },
    {
        id: 'multiShotPermanent',
        label: 'Scatter Array',
        desc: 'Permanently fire 3 projectiles per shot',
        icon: 'fa-code-branch',
        color: '#FF8C00',
        rarity: 'rare',
        available: (gs) => !gs.stats.multiShotPermanent,
        apply(gs) { gs.stats.multiShotPermanent = true; },
    },
    {
        id: 'fullHeal',
        label: 'Emergency Repair',
        desc: 'Fully restore shield to max',
        icon: 'fa-plus-square',
        color: '#22C55E',
        rarity: 'uncommon',
        apply(gs) { gs.health = gs.stats.maxHealth; },
    },
];
